<a class="nav-cell" [class.disabled]="disabled" [href]="link">
  {{ value }}
  <ng-content></ng-content>
</a>